import { FormikContext, useFormik } from "formik";
import { useTranslations } from "use-intl";
import { Button } from "@mui/material";

import type { TFlightFormValues } from "@/app/lib/types/types";
import { TripType } from "@/app/lib/types/enums";

import { Calendar } from "../Calendar";
import TripTypeRadioGroup from "./TripTypeRadioGroup";
import { DatesGuard } from "./DatesGuard";

type Props = {
  initialValues: TFlightFormValues;
  onConfirm: (values: TFlightFormValues) => void;
};

function DatesSelection({ initialValues, onConfirm }: Props) {
  const t = useTranslations();

  const formik = useFormik({
    initialValues,
    onSubmit: onConfirm,
  });

  return (
    <FormikContext.Provider value={formik}>
      <div className="flex h-full flex-col">
        <TripTypeRadioGroup
          value={formik.values.tripType}
          onChange={formik.handleChange}
        />

        <Calendar
          allowSameDayRangeSelection
          startField={{
            label: t("flights.search.departureDate"),
            value: formik.values.dates.departure,
            path: "dates.departure",
          }}
          endField={
            formik.values.tripType === TripType.ROUND_TRIP
              ? {
                  label: t("flights.search.returnDate"),
                  value: formik.values.dates.return,
                  path: "dates.return",
                }
              : undefined
          }
          setFieldValue={formik.setFieldValue}
          disabledDates={{
            before: new Date(),
          }}
          startMonth={new Date()}
        />
        <Button
          fullWidth
          variant="contained"
          size="medium"
          sx={{
            marginTop: "auto",
          }}
          onClick={() => formik.handleSubmit()}
        >
          {t("confirm")}
        </Button>
      </div>
      <DatesGuard />
    </FormikContext.Provider>
  );
}

export default DatesSelection;
